/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Per-task attachment policy.
 */
export type AttachmentPolicy = (typeof AttachmentPolicy)[keyof typeof AttachmentPolicy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttachmentPolicy = {
  none: 'none',
  images: 'images',
  extended: 'extended',
} as const;
